export class Therapy {
  date: string;
  therapy: string;

  constructor(date: string, therapy: string) {
    this.date = date;
    this.therapy = therapy;
  }
}
